import React from 'react';
import PropTypes from 'prop-types';

import "./FeatureTag.scss";

export const FeatureTag = ({tag}) => (
  <li className="feature-tag">{tag}</li>
);

FeatureTag.propTypes = {
  tag: PropTypes.string.isRequired,
};